/**
 * ISO 3166-1 alpha-2 보정 (국기 라이브러리 `<CountryFlag>`용).
 *
 * BE가 내려주는 country/language 코드 중 일부는 alpha-2가 아니거나(EN, JA, KO, ZH, ...)
 * 표준과 다른 관례(UK)를 쓰므로, 표시 직전에 이 맵으로 보정한다.
 * 13개 항목은 이 프로젝트에서 발견된 가장 완전한 버전(구 rosters/index.tsx)을 기준으로 통일.
 */
export const COUNTRY_CODE_FIX: Record<string, string> = {
  UK: 'GB', EN: 'GB', EL: 'GR', JA: 'JP', KO: 'KR', ZH: 'CN',
  CS: 'CZ', DA: 'DK', HE: 'IL', HI: 'IN', SV: 'SE', VI: 'VN',
  MS: 'MY', TL: 'PH',
};

/** code를 대문자·trim 후 COUNTRY_CODE_FIX로 보정. 빈 값은 ''. */
export function fixCountryCode(code?: string | null): string {
  if (!code) return '';
  const upper = code.trim().toUpperCase();
  return COUNTRY_CODE_FIX[upper] ?? upper;
}
